import React, { createContext, useReducer } from 'react';
import { customerModel } from '../../models/CustomerEntity';
import { countriesEnum, TaxCondition } from '../../models/EnumEntity';

export const CustomerContext = createContext();

const MapCustomer = ( customer ) => {
    const taxCondition = TaxCondition
        .find(c => c.label === customer?.taxCondition || c.value === customer?.taxCondition);

    return {
        ...customer,
        taxCondition: taxCondition?.value,
        email: customer?.email?.trim(),
        addresses: []
    }
}

const GetFullAddress = (address) => {
    address.fullAddress = `${address.street} ${address.number}`;

    if (address.floor)
        address.fullAddress += `, ${address.floor}`;

    if (address.apartment)
        address.fullAddress += ` ${address.apartment}`;

    address.fullAddress += `, ${address.city}, ${address.province}, ${countriesEnum[address.country]}`;

    if (address.country === countriesEnum.AR)
        address.fullAddress += `, CP ${address.postalCode}`

    return address;
}

const CustomerProvider = ({ children, customer }) => {
    const initialData = customer 
        ? MapCustomer(customer) 
        : customerModel;
    
    const CustomerReducer = (state, action) => {
        switch (action.type) {
            case 'SET_CUSTOMER': 
            return {
                ...state,
                ...MapCustomer(action.payload),
            }
            
            case 'EDIT_CUSTOMER':
                return {
                    ...state,
                    ...action.payload,
                }
            case 'REPLACE_CUSTOMER':
                return action.payload || customerModel;
            case 'REPLACE_ADDRESS':
                return {
                    ...state,
                    addresses: action.payload
                }
            case 'ADD_ADDRESS':
                return {
                    ...state,
                    addresses: [...(state.addresses || []), GetFullAddress(action.payload)]
                };
            case 'UPDATE_ADDRESS':
                return {
                    ...state,
                    addresses: state.addresses.map(address =>
                        address.id === action.payload.id 
                            ? GetFullAddress(action.payload)
                            : address)
                }
            case 'DELETE_ADDRESS':
                return {
                    ...state,
                    addresses: state.addresses
                        .filter(address => address.id !== action.payload.id)
                }
            case 'REPLACE_TAXCONFIG':
                return {
                    ...state,
                    taxConfig: action.payload
                }
            default:
                return state
        }
    }

    return (
        <CustomerContext.Provider value={useReducer(CustomerReducer, initialData)}>
            {children}
        </CustomerContext.Provider>
    )
}

export default CustomerProvider;